const updateUrlWithoutReload = (url)=>{
    if (window.history) {
        window.history.replaceState({
            path: url
        }, window.document.title, url);
    }
};
const updateUrlWithReload = (url)=>{
    if (window.history) {
        window.history.pushState({
            path: url
        }, window.document.title, url);
    }
};

export { updateUrlWithReload, updateUrlWithoutReload };
//# sourceMappingURL=update-url.js.map
